<template>
  <div
    class="validation-message error"
    v-if="validation.$error"
  >
    <!-- TODO: Convert to one p element -->
    <p v-if="!validation.required">{{ metadata.label }} is required</p>
    <p v-else-if="!validation.minLength">{{ metadata.label }} should be more than {{ metadata.minLength }} characters</p>
    <p v-else-if="!validation.maxLength">{{ metadata.label }} should be less than {{ metadata.maxLength }} characters</p>
    <p v-else-if="!validation.pattern">{{ metadata.patternDescription }}</p>
    <p v-else-if="!validation.minValue">{{ metadata.label }} can't be less than {{ metadata.minimum }}</p>
    <p v-else-if="!validation.maxValue">{{ metadata.label }} can't be more than {{ metadata.maximum }}</p>
  </div>
  <div
    class="helper-text"
    v-else-if="metadata && metadata.message"
  >
    <p>{{ metadata.message }}</p>
  </div>
</template>

<script>
export default {
  name: 'ValidationMessage',
  props: {
    validation: {
      type: Object
    },
    metadata: {
      type: Object
    }
  }
}
</script>
